<template>
  <AppNavbar/>
  <HeroSection :statics="statics"/>
  <div class="container">
    <!-- About Us Section-->
    <AboutUs />
    <!-- Services -->
    <OurServices />
    <!-- Quran Programs -->
    <QuranPrograms v-if="eduPrograms.length" :programs="eduPrograms" />
    <!-- QuranProgramsSchedules -->
    <QuranProgramsSchedules />
    <!-- Advocacy Pillar -->
    <AdvocacyPillar />
    <!-- Last News-->
    <LastNews :news="news"/>
    <!--testimonial-->
    <TestimonialData />
    <!-- DownloadApplication-->
     <DownloadApplication/>

  </div>
  <AppFooter/>
</template>

<script>
import AboutUs from '../components/Home/AboutUs.vue';
import OurServices from '../components/Home/OurServices.vue';
import QuranPrograms from '../components/Home/QuranPrograms.vue';
import QuranProgramsSchedules from '../components/Home/QuranProgramsSchedules.vue';
import AdvocacyPillar from '../components/Home/AdvocacyPillar.vue';
import LastNews from '../components/Home/LastNews.vue';
import TestimonialData from '../components/Home/TestimonialData.vue';
import DownloadApplication from '../components/Home/DownloadApplication.vue';
import AppFooter from '../components/AppFooter.vue';
import HeroSection from '../components/Home/HeroSection.vue';
import AppNavbar from '../components/AppNavbar.vue';

import Home from "../api/home";

export default {
  name: 'App',
  components: {
    AboutUs,
    OurServices,
    QuranPrograms,
    QuranProgramsSchedules,
    AdvocacyPillar,
    LastNews,
    TestimonialData,
    DownloadApplication,
    AppFooter,
    HeroSection,
    AppNavbar
  },
  async created(){
    let programs = await new Home().QuranPrograms({ per_page: 3, with : ['students'] });
    this.eduPrograms = programs.data;

    let statics = await new Home().Statics();
    this.statics = statics;


    let news = await new Home().News({per_page : 1})
    this.news = news.data
  },
  data(){
    return {
      eduPrograms : [],
      statics : {},
      news : []
    }
  }
}
</script>

<style></style>
